import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Base from "../admin_components/Admin_Base";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function ThirtyPercentTransactionsList() {
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("ALL");

  useEffect(() => {
    fetchTransactions();
  }, []);

  useEffect(() => {
    applyFilter();
  }, [filter, transactions]);

  const fetchTransactions = async () => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token || token === "null" || token === "undefined") {
        Swal.fire({
          icon: "error",
          title: "Unauthorized",
          text: "Please log in to view transactions.",
        });
        return;
      }

      const response = await fetch(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-thirty-percent-transactions`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        Swal.fire({
          icon: "error",
          title: "Failed to fetch",
          text: `Error ${response.status}: ${response.statusText}`,
        });
        return;
      }

      const data = await response.json();
      console.log("Fetched transactions:", data);
      if (Array.isArray(data)) {
        setTransactions(data);
      } else {
        console.error("Invalid response format:", data);
        setTransactions([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Could not fetch transactions.",
      });
    } finally {
      setLoading(false);
    }
  };

  const applyFilter = () => {
    if (filter === "ELIGIBLE") {
      setFilteredTransactions(
        transactions.filter((txn) => txn.EligibleForPlot)
      );
    } else if (filter === "NOT_ELIGIBLE") {
      setFilteredTransactions(
        transactions.filter((txn) => !txn.EligibleForPlot)
      );
    } else {
      setFilteredTransactions(transactions);
    }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredTransactions);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "30% Transactions");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(file, "thirty_percent_transactions.xlsx");
  };

  return (
    <Base>
      <div className="container mt-5 pt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>30% Customer Transactions</h2>
          <div className="d-flex gap-2">
            <select
              className="form-select"
              style={{ width: 200 }}
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="ALL">All</option>
              <option value="ELIGIBLE">Eligible Only</option>
              <option value="NOT_ELIGIBLE">Not Eligible</option>
            </select>
            <button className="btn btn-success" onClick={exportToExcel}>
              Export as Excel
            </button>
          </div>
        </div>

        {loading ? (
          <p>Loading transactions...</p>
        ) : filteredTransactions.length === 0 ? (
          <p>No transactions found.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>Customer Name</th>
                  <th>Area Name</th>
                  <th>Amount</th>
                  <th>Amount Paid Till Now</th>
                  <th>Remaining 30% Amount</th>
                  <th>Payment Date</th>
                  <th>Eligible for Plot</th>
                  <th>Transaction ID</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions.map((txn, index) => (
                  <tr key={txn.txnId || index}>
                    <td>{index + 1}</td>
                    <td>{txn.customerName}</td>
                    <td>{txn.areaName}</td>
                    <td>₹{txn.amount}</td>
                    <td>₹{txn.amountPaidTillNow}</td>
                    <td>₹{txn.remainingThirtyPercentAmount}</td>
                    <td>{new Date(txn.paymentDate).toLocaleDateString()}</td>
                    <td>
                      {txn.eligibleForPlot ? (
                        <span className="text-success">Yes</span>
                      ) : (
                        <span className="text-danger">No</span>
                      )}
                    </td>
                    <td>{txn.txnId}</td>
                    <td>
                      {txn.status === "SUCCESS" ? (
                        <span className="badge bg-success">{txn.status}</span>
                      ) : (
                        <span className="badge bg-danger">{txn.status}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Base>
  );
}
